import { render, staticRenderFns } from "./AssignTraineeClass.vue?vue&type=template&id=3ca60f15"
import script from "./AssignTraineeClass.vue?vue&type=script&lang=js"
export * from "./AssignTraineeClass.vue?vue&type=script&lang=js"
import style0 from "./AssignTraineeClass.vue?vue&type=style&index=0&id=3ca60f15&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports